<div>
  <h4>Search for a Contract Number</h4>
  <mat-form-field class="selection-input" appearance="fill">
    <mat-label>Contract Number</mat-label>
    <input matInput
           [formControl]="inputFormControl"
           [matAutocomplete]="auto"
           data-test="NewRequestTextInput">
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelected($event.option.value)">
      <mat-option *ngFor="let option of typeAheadOptions" [value]="option">
        {{ option.contractNumber }}
      </mat-option>
    </mat-autocomplete>
    <mat-error *ngIf="inputFormControl.hasError('invalidContractNumber')">
      Select a valid contract number.
    </mat-error>
    <mat-error *ngIf="inputFormControl.hasError('required')">
      This field is required.
    </mat-error>
  </mat-form-field>
</div>
<hr>
<div class="info-display" data-test="NewRequestInfoDisplay">
  <h3>Confirm this is the correct contract:</h3>
  <p><strong>Contract Number:</strong> {{selectedOption?.contractNumber}}</p>
  <p><strong>Supplier:</strong> {{selectedOption?.supplier}}</p>
</div>
